import Meta from 'src/components/meta/Meta';

const AboutMeta = () => <Meta
  title="About Us | BrickX"
  description="The BrickX team is passionate about creating easy and affordable access to the property market for all Australians. Learn more about the team."
/>;

export default AboutMeta;
